export type ColorShade = {
    main: string;
    30: string;
    40: string;
    50: string;
    100: string;
    200: string;
    300: string;
    400: string;
    500: string;
    600: string;
    700: string;
    800: string;
    900: string;
};

export type PaletteMode = 'light' | 'dark';

const sharedColors = {
    primary: {
        main: '#307FE2',
        30: '#F0F7FF',
        40: '#E9F5FF',
        50: '#E3F1FD',
        100: '#D6E8FC',
        200: '#BBDBFB',
        300: '#91C6F8',
        400: '#66AFF5',
        500: '#499EF3',
        600: '#318EF0',
        700: '#307FE2',
        800: '#295DBC',
        900: '#233F9D',
    } as ColorShade,
    green: {
        main: '#0A891B',
        30: '#F3F9F4',
        40: '#E6F3E8',
        50: '#CEE7D1',
        100: '#B6DCBB',
        200: '#9DD0A4',
        300: '#84C48D',
        400: '#6CB876',
        500: '#53AC5F',
        600: '#3BA049',
        700: '#0A891B',
        800: '#097B18',
        900: '#076013',
    } as ColorShade,
    yellow: {
        main: '#F1BE0C',
        30: '#FEF9E7',
        40: '#FCF2CE',
        50: '#FBECB6',
        100: '#F9E59E',
        200: '#F8DF85',
        300: '#F7D86D',
        400: '#F5D255',
        500: '#F4CB3D',
        600: '#F2C424',
        700: '#F1BE0C',
        800: '#C0970B',
        900: '#A98508',
    } as ColorShade,
    red: {
        main: '#E80604',
        30: '#FDE6E6',
        40: '#FACDCD',
        50: '#F8B4B4',
        100: '#F69B9B',
        200: '#F48281',
        300: '#F16A68',
        400: '#EF514F',
        500: '#ED3836',
        600: '#EA1F1D',
        700: '#E80604',
        800: '#D10504',
        900: '#A20403',
    } as ColorShade,
    blue: {
        main: '#307FE2',
        30: '#F0F7FF',
        40: '#E9F5FF',
        50: '#E3F1FD',
        100: '#D6E8FC',
        200: '#BBDBFB',
        300: '#91C6F8',
        400: '#66AFF5',
        500: '#499EF3',
        600: '#318EF0',
        700: '#307FE2',
        800: '#295DBC',
        900: '#233F9D',
    } as ColorShade,
    twilightBlue: {
        main: '#233F9D',
        30: '#E9ECF5',
        40: '#D3D9EB',
        50: '#BDC5E2',
        100: '#A7B2D8',
        200: '#919FCE',
        300: '#7B8CC4',
        400: '#6579BA',
        500: '#4F65B1',
        600: '#3952A7',
        700: '#233F9D',
        800: '#1F398D',
        900: '#182C6E',
    } as ColorShade,
    grey: {
        main: '#4D5559',
        30: '#F6F7FA',
        40: '#ECF0F5',
        50: '#E2E8EE',
        100: '#CAD2D9',
        200: '#ADB8BE',
        300: '#939DA5',
        400: '#808B90',
        500: '#69787F',
        600: '#5D696F',
        700: '#4D5559',
        800: '#343F46',
        900: '#141E25',
    } as ColorShade,
    white: '#FFF',
    black: '#000',
};

export const colors = (_mode: PaletteMode = 'light') => ({ ...sharedColors });
